import { Box, styled } from '@mui/material';

export const LocationSearchWrapper = styled(Box)`
  .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon.mui-1tlcqt-MuiAutocomplete-root
    .MuiFilledInput-root {
    padding-right: 0;
  }
`;
